const lowerbody1_week3 = [
  {
    name: "Leg Press",
    details: "Machine",
    sets: [
      { load: "170", reps: 15, rir: 2, rest: "60s" },
      { load: "190", reps: 15, rir: 2, rest: "60s" },
      { load: "210", reps: 15, rir: 2, rest: "60s" },
      { load: "N/A", reps: "N/A", rir: "N/A", rest: "N/A" },
    ],
    notes: "Push through your heels.",
  },
  {
    name: "Single Leg, Lying, Eccentric Hamstring Curl",
    details: "Machine",
    sets: [
      { load: "18", reps: 15, rir: 2, rest: "60s" },
      { load: "18", reps: 20, rir: 2, rest: "60s" },
      { load: "N/A", reps: "N/A", rir: "N/A", rest: "N/A" },
      { load: "N/A", reps: "N/A", rir: "N/A", rest: "N/A" },
    ],
    notes: "Engage your glutes throughout the movement. Add tempo to exercise.",
  },
  {
    name: "Glute Drive",
    details: "Machine",
    sets: [
      { load: "100", reps: 15, rir: 2, rest: "60s" },
      { load: "100", reps: 15, rir: 2, rest: "60s" },
      { load: "N/A", reps: "N/A", rir: "N/A", rest: "N/A" },
      { load: "N/A", reps: "N/A", rir: "N/A", rest: "N/A" },
    ],
    notes: "Hold at the top for 2 seconds.",
  },
  {
    name: "Standing Side Cable Abduction",
    details: "Cable Machine",
    sets: [
      { load: 14, reps: 15, rir: 2, rest: "60s" },
      { load: 14, reps: 15, rir: 2, rest: "60s" },
      { load: "N/A", reps: "N/A", rir: "N/A", rest: "N/A" },
      { load: "N/A", reps: "N/A", rir: "N/A", rest: "N/A" },
    ],
    notes: "Keep your upper body steady.",
  },
  {
    name: "Seated Adductor Machine",
    details: "Machine",
    sets: [
      { load: "150", reps: 15, rir: 2, rest: "60s" },
      { load: "165", reps: 15, rir: 2, rest: "60s" },
      { load: "165", reps: 15, rir: 2, rest: "60s" },
      { load: "N/A", reps: "N/A", rir: "N/A", rest: "N/A" },
    ],
    notes: "Control the movement both ways. Add stimulus algorithm.",
  },
];

export default lowerbody1_week3;
